import * as analytics from 'analytics/Analytics';
import AnnotateDomainSequencesSettingsModal from 'antibodies/domain-annotation/AnnotateDomainSequencesSettingsModal';
import {DomainSequenceType} from 'antibodies/domain-annotation/DomainAnnotationTypes';
import startDomainSequenceAnnotation from 'antibodies/domain-annotation/startDomainSequenceAnnotation';
import {ANTIBODIES_ANALYTICS_ACTIONS} from 'constants/analytics-products/AntibodiesAnalyticsConstants';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import {ZINDEX_MODAL} from 'styles/StyleConstants';
import runModal from 'ui-library/runModal';

/**
 * Prompts for annotation settings and starts annotating existing domain sequences of one sequence type.
 * Dismissing the modal annotates nothing.
 *
 * @param initialFolderId Prefills the folder for the annotation results dataset.
 * @param actionOrigin Where the user started the annotation, recorded on its analytics events.
 * @param onAnnotated See `startDomainSequenceAnnotation`.
 */
export default async function promptAndAnnotateDomainSequences({
  sequenceIds,
  sequenceType,
  initialFolderId,
  actionOrigin,
  onAnnotated,
}: {
  sequenceIds: Array<string>;
  sequenceType: DomainSequenceType;
  initialFolderId: string | null;
  actionOrigin: ActionOrigin;
  onAnnotated?: (annotatedSequenceIds: Array<string>) => void;
}): Promise<void> {
  analytics.trackEvent(ANTIBODIES_ANALYTICS_ACTIONS.OPENED_DOMAIN_ANNOTATION_MODAL, {
    actionOrigin,
    sequenceType,
    sequenceCount: sequenceIds.length,
  });
  const config = await runModal(
    AnnotateDomainSequencesSettingsModal,
    {
      sequenceType,
      initialFolderId,
      submitButtonText: 'Annotate',
      showAnnotationToggle: false,
    },
    {
      title: `Annotate ${sequenceType} domain entities`,
      size: 'lg',
      zIndex: ZINDEX_MODAL,
    }
  );
  if (config == null) {
    return;
  }
  startDomainSequenceAnnotation({sequenceIds, config, actionOrigin, onAnnotated});
}
